/*
 * Copyright © 2025 Apple Inc. Adapted for Bowstring from SF Symbols Version 6.0.
 */

import { type Symbol } from "@bowstring/interfaces";


// noinspection JSUnusedGlobalSymbols
export const _Eurosign: Symbol = {
  paths:         [
    {
      definition: "M18.0234 26.8008C18.8672 26.8008 19.9219 26.7656 20.6836 26.5898C21.3984 26.4258 21.8789 26.0977 21.8789 25.418C21.8789 24.6445 21.375 24.3281 20.6719 24.3281C19.9102 24.3281 19.5117 24.4805 18.1172 24.4805C11.4141 24.4805 7.06641 20.4609 7.06641 13.5L7.06641 13.3008C7.06641 6.44531 11.2617 2.35547 18.0469 2.35547C19.0664 2.35547 20.3086 2.51953 20.6719 2.51953C21.4219 2.51953 21.8789 2.13281 21.8789 1.41797C21.8789 0.714844 21.375 0.375 20.6836 0.199219C19.875 0.0117188 18.8203 0 18.0469 0C10.0312 0 4.44141 4.79297 4.44141 13.3711L4.44141 13.4297C4.44141 21.7383 9.67969 26.8008 18.0234 26.8008ZM0 10.7578C0 11.2617 0.351562 11.6133 0.84375 11.6133L17.4727 11.6133C18 11.6133 18.3398 11.2734 18.3398 10.7578C18.3398 10.2305 18 9.87891 17.4727 9.87891L0.84375 9.87891C0.351562 9.87891 0 10.2422 0 10.7578ZM0 16.1016C0 16.6172 0.351562 16.9688 0.84375 16.9688L17.4727 16.9688C18 16.9688 18.3398 16.6289 18.3398 16.1133C18.3398 15.5859 18 15.2344 17.4727 15.2344L0.84375 15.2227C0.351562 15.2227 0 15.5859 0 16.1016Z",
      opacity:    0.85,
    },
  ],
  viewBoxHeight: 26.8242,
  viewBoxWidth:  22.2305,
};
